import type {Schemas} from 'api/dto.generated';
import {ebsApi} from 'store/ebsApi';
import type {GetUpdateLogParams, UpdateLogPage} from './types';
import {mapUpdateLogsDto} from './mappers';

export const updateLogApi = ebsApi.injectEndpoints({
  endpoints: build => ({
    getUpdateLog: build.query<
      UpdateLogPage,
      GetUpdateLogParams,
      Schemas.UpdateLogsDto
    >({
      query: ({from, to, page, size}) => ({
        url: 'updatelog',
        params: {
          from,
          to,
          page,
          size,
          sort: 'created,desc',
        },
      }),
      transformResponse: mapUpdateLogsDto,
    }),
  }),
});

export const {useGetUpdateLogQuery} = updateLogApi;
